import { Col } from "antd";
import { useEffect, useRef, useState } from "react";
import background from "../../../../assets/FONDO_CALENDLY.jpg";
import Loader from "../../../../components/UI/loader";
import { CalendarLayout } from "./styles";
export const Calendar = () => {
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    // Inyecta el script solo una vez
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    // Observa cuándo se carga el iframe dentro del contenedor
    const observer = new MutationObserver(() => {
      const iframe = containerRef.current?.querySelector("iframe");
      if (iframe) {
        setLoading(false);
        observer.disconnect();
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <CalendarLayout image={background}>
      <Col span={24}>
        <div
          id="contact"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        >
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "transparent",
                zIndex: 1,
              }}
            >
              <Loader />
              {/* Aquí puedes poner un spinner */}
            </div>
          )}
          <div
            ref={containerRef}
            className="calendly-inline-widget scroll-hidden"
            data-url="https://calendly.com/icancha-info/30min?primary_color=1e3799"
            style={{ minWidth: "350px", width: "100%", height: "100%" }}
          />
        </div>
      </Col>
    </CalendarLayout>
  );
};
